import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "react-bootstrap";
import UploadImageTwo from "../../../assests/images/review-preview-images/review-preview-2.webp";
import VideoPlayIcon from "../../../assests/images/play-icon.svg";
import { MESSAGE } from "../../../utils/message";
import {
  NonprofitMediaGallery,
  MediaGallerySubTitle,
  MediaGalleryBox,
  MediaGalleryImageBox,
  MediaGalleryImagGroup,
  PlayButton,
  SectionTitle,
  Title,
  SectionButton,
} from "./nonprofitMediaGalleryStyle";
import { useParams } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { nonprofitMediaHandler } from "../../../redux/slices/myNonprofit/nonprofitMedia-slice";

interface Props {
  setKey: (val: string) => void;
}
const MediaGallery = ({ setKey }: Props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const mediaList = useSelector(
    (state: any) => state?.nonprofitMedia?.data?.results
  );
  useEffect(() => {
    if (id) dispatch(nonprofitMediaHandler(id) as any);
  }, [id]);
  return (
    <>
      <SectionTitle>
        <Title>{MESSAGE.nonProfitMediaGallery}</Title>
        <SectionButton
          className="btn-outline-success-blue"
          onClick={() => setKey(`/dashboard/edit/${id}`)}
        >
          Edit or Add Media
        </SectionButton>
      </SectionTitle>
      <NonprofitMediaGallery>
        <MediaGallerySubTitle>{MESSAGE.photosVideos}</MediaGallerySubTitle>
        <MediaGalleryBox>
          <MediaGalleryImagGroup>
          {Array.isArray(mediaList) &&
  mediaList?.map((item, _i) => {
    let content;

    if (item?.image) {
      content = (
        <MediaGalleryImageBox key={item?.id}>
          <Image src={item?.image} alt="upload image one" />
        </MediaGalleryImageBox>
      );
    } else if (item?.vedio_url) {
      content = (
        <MediaGalleryImageBox key={item?.id}>
          <Image src={UploadImageTwo} alt="upload image two" />
          <PlayButton className="play-button">
            <Image src={VideoPlayIcon} alt="video play icon" />
          </PlayButton>
        </MediaGalleryImageBox>
      );
    } else {
      content = null;
    }

    return content;
  })}

          </MediaGalleryImagGroup>
        </MediaGalleryBox>
      </NonprofitMediaGallery>
    </>
  );
};

export default MediaGallery;
